var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.53 103.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.81,101.9C31.48,95,1,54.9,1,36.8a35.77,35.77,0,0,1,71.53-.08C72.55,54.82,42.12,95,36.81,101.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.77,0V2h0A34.81,34.81,0,0,1,71.53,36.73c0,17-27.76,54.42-34.73,63.53C29.83,91.17,2,53.84,2,36.8A34.8,34.8,0,0,1,36.73,2l0-2m0,0h-.05A36.76,36.76,0,0,0,0,36.81c0,20.3,36.81,66.72,36.81,66.72S73.55,57,73.53,36.72A36.76,36.76,0,0,0,36.77,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.11da8971.svg";
export { ForwardRef as ReactComponent };